import { Type } from 'class-transformer';
import { IsDefined, IsEnum, IsNotEmpty, ValidateNested } from 'class-validator';
import { BaseDto } from '../../@base/base.dto';
import { ContactInfosDto } from '../../administrative';
import { UserRegistrationId } from '../../types';
import { UserRegistrationConfirmationDto } from './user-registration-confirmation.dto';
import { UserRegistrationIdentityDto } from './user-registration-identity.dto';
import { UserRegistrationStep } from './user-registration-step.enum';

export class UserRegistrationSummaryDto extends BaseDto<UserRegistrationId> {
  @ValidateNested()
  @Type(() => UserRegistrationIdentityDto)
  @IsDefined()
  identity!: UserRegistrationIdentityDto;

  @ValidateNested()
  @Type(() => ContactInfosDto)
  @IsDefined()
  contactInfos!: ContactInfosDto;

  @ValidateNested()
  @Type(() => UserRegistrationConfirmationDto)
  confirmation!: UserRegistrationConfirmationDto;

  @IsEnum(UserRegistrationStep)
  @IsNotEmpty()
  step!: UserRegistrationStep;
}
